// Application constants
// Note: RESTAURANT_ID should be obtained from user context after login
export const TABLE_ID = "67b0d520467c77abcaefa8bb";

export const FILTER_OPTIONS = {
  CATEGORY: {
    ALL: "all",
    STARTERS: "starters",
    SOUPS: "soups",
    BREADS: "breads",
    RICE: "rice",
    BIRYANI: "biryani",
    MAIN_COURSE: "mainCourse",
    CURRIES: "curries",
    TANDOOR: "tandoor",
    CHINESE: "chinese",
    BEVERAGES: "beverages",
    DESSERT: "dessert",
    TODAYS_SPECIAL: "todaysSpecial",
    BREAKFAST: "breakfast",
    LUNCH: "lunch",
    MEAL: "meal"
  },
  TYPE: {
    ALL: "all",
    VEG: "veg",
    NON_VEG: "nonveg"
  }
};

export const SERVICE_CHARGE_TIERS = {
  LOW: { threshold: 100, charge: 2 },
  MEDIUM: { threshold: 500, charge: 5 },
  HIGH: { charge: 10 }
};

export const ITEM_IMAGES = {
  VEG: "https://logodix.com/logo/1726670.jpg",
  NON_VEG: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Non_veg_symbol.svg/2048px-Non_veg_symbol.svg.png"
};

export const DEFAULT_TAX_PERCENTAGE = 5;